import { ThemeEvents } from '@theme/events';

/**
 * Floating Panel Manager
 *
 * Centralized script that manages the opening/closing behavior of all floating panels.
 * When a floating panel opens, all other open details elements are closed.
 *
 * This script listens for the 'floating-panel:opened' event and handles the closing
 * logic globally, so individual components don't need to manage this themselves.
 */

/**
 * Handles floating panel opened events
 * Closes all open details elements except the one that just opened
 * @param {CustomEvent} event - The floating panel opened event
 */
function handleFloatingPanelOpened(event) {
  const openedParentDetails = event.detail.parentDetails;

  // Find all open details elements and close them except the one that just opened
  document.querySelectorAll('details[open]').forEach(details => {
    if (details !== openedParentDetails) {
      details.removeAttribute('open');
    }
  });
}

// Set up the event listener when the script loads
document.addEventListener(ThemeEvents.floatingPanelOpened, handleFloatingPanelOpened);
